import './App.css';
import Anime from './components/AnimeQueryWrap.js';


function App() {
  return (                
    <Anime/>
  );
}

export default App;
